import styled, { css } from 'styled-components';

export const IntersectBox = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings[10]};
    padding: ${theme.spacings[12]};
    border-radius: 12px;
    background: ${theme.colors.white || '#fff'};
    border: 1px solid ${theme.colors.gray200 || '#e4e9f2'};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[12]};

    width: 446px;

    @media (max-width: 1600px) {
      width: 372px;
    }

    @media (max-width: 1000px) {
      width: 353px;
    }

    @media (max-width: 800px) {
      width: 317px;
    }

    @media (max-width: 600px) {
      width: 467px;
    }

    @media (max-width: 400px) {
      left: 267px;
    }
  `}
`;

export const IntersectHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-weight: 600;
  font-size: 14px;

  svg {
    font-size: 16px;
  }
`;